import React, { FC } from 'react';
import { IconPickerIcon, PickableIconPack } from '../IconPicker';
import './badge.scss';
import { BadgeSvg } from './svg';

export type BadgeProps = {
  iconPack: PickableIconPack;
  iconName: string;
  iconColor: string;
  badgeColor: string;
  size?: 'xs' | 'sm' | 'lg';
};

const getBadgeDimensions = (size: string) => {
  switch (size) {
    case 'lg':
      return { width: 84, height: 99 };
    case 'sm':
      return { width: 36, height: 43 };
    case 'xs':
      return { width: 26, height: 34 };
    default:
      return { width: 84, height: 99 };
  }
};

export const Badge: FC<BadgeProps> = ({ iconPack, iconName, iconColor, badgeColor, size = 'lg' }) => {
  const { width, height } = getBadgeDimensions(size);
  return (
    <div className={`hl-badge hl-badge-${size}`}>
      <BadgeSvg color={badgeColor} width={width} height={height} />
      <div className="icon-container" style={{ color: iconColor }}>
        <IconPickerIcon iconPack={iconPack} iconName={iconName} />
      </div>
    </div>
  );
};

export default Badge;
